import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-service-scaling-dialog',
    templateUrl: './service-scaling-dialog.component.html',
    styleUrls: ['./service-scaling-dialog.component.scss'],
    standalone: false
})
export class ServiceScalingDialogComponent implements OnInit {
	maxCount: number = 1;

	constructor(
		public dialogRef: MatDialogRef<ServiceScalingDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		if (this.data && this.data.maxCount != null) {
			this.maxCount = this.data.maxCount;
		}
	}

	ok(): void {
		this.dialogRef.close({ maxCount: this.maxCount });
	}
}
